'use client'

import Head from 'next/head'
import Image from 'next/image'

export default function TrustPilotRatings() {
  return (
    <>
      <Head>
        <script
          async
          src="//widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js"
        ></script>
      </Head>

      <div style={{ width: 301 }} className="mb-4">
        <div
          className="trustpilot-widget"
          data-locale="en-US"
          data-template-id="5419b6a8b0d04a076446a9ad"
          data-businessunit-id="642e5d5bc70cd42f53e01b3e"
          data-style-height="30px"
          data-style-width="100%"
          data-theme="light"
          data-min-review-count="10"
          data-without-reviews-preferred-string-id="1"
          data-style-alignment="center"
        >
          <a
            href="https://www.trustpilot.com/review/locker.io"
            target="_blank"
            rel="noopener"
            className="flex justify-center"
          >
            <Image
              src={`/images/home/platforms/Trustpilot.svg`}
              alt="Trustpilot"
              style={{ height: 50, width: 'auto' }}
              height={50}
              width={50}
            />
          </a>
        </div>
      </div>
    </>
  )
}
